// extracted by mini-css-extract-plugin
export default {"header":"TaskContainer_header__JpQd0","TaskContainer":"TaskContainer_TaskContainer__1qwVv"};